import { useStore } from 'vuex'
import { ref, computed } from 'vue'
import AttachmentsEditor from 'components/AttachmentsEditor/AttachmentsEditor.vue';

export default {
    name: "UploadNewFileOverlay",
    components: {
        AttachmentsEditor
    },
    setup(){
        const store = useStore()

        const filesToUpload = ref([])

        const isSubmitting = computed(()=> store.state.frivillige.is_submitting)
        const isSubmissionError = ref(false)
        const isValid = computed(() => filesToUpload.value.length > 0)

        const submitUploadNewFile = () => {
            if (filesToUpload.value.length === 0)
                return

            isSubmissionError.value = false

            store.dispatch("frivillige/submitUploadNewFile", {
                files: filesToUpload.value
            })
            .then(() => {
                store.dispatch('main/closePageOverlay')
                store.dispatch('search/refreshSearches')
            })
            .catch(() => {
                isSubmissionError.value = true
            })
        };

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "UploadNewFileOverlay",
                labelKey: labelKey,
            });

        return {
            getLabel,
            isSubmitting,
            isSubmissionError,
            isValid,
            filesToUpload,
            submitUploadNewFile,
        }
    }
}